import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import contactPromptImage from '@backrs_ui/grow-ui/src/assets/images/contact-prompt.jpg';
import { SANDBOX_CONTACT_FORM_URL } from '@backrs_ui/grow-ui/src/settings';

import { Box, Button, Dialog, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.sandboxPromptModal;

type ContactPromptModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
}>;

export const ContactPromptModal = ({ open, onClose }: ContactPromptModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth sx={dialogSx}>
      <Box sx={containerSx}>
        <Box component="img" src={contactPromptImage} alt="" sx={imageSx} />
        <Box sx={textSx}>
          <Typography variant="text-lg-semibold" sx={titleSx}>
            {STRINGS.title}
          </Typography>
          <Typography variant="text-sm-regular" sx={subtitleSx}>
            {STRINGS.subtitle}
          </Typography>
        </Box>
        <Box sx={actionsSx}>
          <Button
            id="contact-prompt-modal-cancel-btn"
            hierarchy="Secondary gray"
            size="lg"
            fullWidth
            onClick={onClose}
          >
            {STRINGS.cancel}
          </Button>
          <Button
            id="contact-prompt-modal-lets-talk-btn"
            hierarchy="Primary"
            size="lg"
            fullWidth
            onClick={() => window.open(SANDBOX_CONTACT_FORM_URL, '_blank')}
          >
            {STRINGS.cta}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

const dialogSx: SxProps<Theme> = ({ backrs }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '400px',
    borderRadius: backrs.radius['radius-xl'],
    boxShadow: backrs.shadows['shadow-xl'],
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  },
});

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  padding: backrs.spacing['spacing-3xl'],
});

const imageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  aspectRatio: '352 / 208',
  objectFit: 'cover',
  borderRadius: backrs.radius['radius-md'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-quaternary']}`,
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  textAlign: 'center',
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: backrs.spacing['spacing-lg'],
});
